module.exports = __webpack_public_path__ + "static/Montserrat-300-2f354053d1c9c36f533ebd226698bfa5.ttf";